import React from "react"
import { Link as GatsbyLink } from "gatsby"

import { Text } from "legacy/components/shared/base"
import { linkResolver } from "src/legacy/utils"

interface elementType {
  data?: {
    id?: string
    isOneLink?: boolean
    link_type?: string
    url?: string
  }
}

const LinkSerializer = (
  type: string,
  element: elementType,
  content: string
): React.ReactElement | null => {
  const linkType = (element.data && element.data.link_type) || type
  const isOneLink = element?.data?.isOneLink

  if (linkType === "Document") {
    return (
      <GatsbyLink to={linkResolver(element.data)} key={element.data?.id}>
        {content}
      </GatsbyLink>
    )
  } else if (linkType === "Web" || linkType === "hyperlink") {
    let onClickHandler = (): void => {}
    if (isOneLink) {
      onClickHandler = (): void | null => {
        analytics.track("Download Button Clicked")
      }
    }

    return (
      <Text
        as="a"
        fontSize={["17", "text.body"]}
        href={element.data?.url}
        key={element.data?.id}
        onClick={isOneLink ? () => onClickHandler() : null}
      >
        {content}
      </Text>
    )
  }

  return null
}

export default LinkSerializer
